"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CHECKOUT_TYPE = exports.NOT_AVAILABLE = void 0;
exports.NOT_AVAILABLE = "not-available";
exports.DEFAULT_CHECKOUT_TYPE = "regular-checkout";
